import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useCheckboxFieldStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        marginRight: 0,

        '&.fullWidth': {
          width: '100%'
        }
      },

      checkbox: {
        paddingTop: 0,
        paddingBottom: 0,

        '&.isSquare': {
          display: 'none'
        }
      },

      label: {
        justifyContent: 'center',
        margin: '0 5px 10px',
        padding: 15,
        minHeight: 56,
        minWidth: 113,
        borderRadius: 4,

        '&.checked': {
          backgroundColor: theme.palette.secondary.main,
          color: '#FFF'
        }
      },

      radio: {
        display: 'none'
      },

      text: {
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }),

  { name: 'CheckboxField' }
)
